export const RESET_SPACING_CLASS_NAME = 'reset-space'
